module.exports = __webpack_public_path__ + "static/media/output_r.98f38f98.png";